import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Barra scorrevole generica (stile breaking news) con voci cliccabili interne al sito. */
export const NewsTicker = ({ testid, label, icon: Icon, items, tone = "dark", duration = 40 }) => {
  if (!items.length) return null;
  const loop = [...items, ...items];
  const bar = tone === "dark" ? "bg-neutral-900 text-neutral-200 border-neutral-800" : "bg-white text-black border-neutral-200";
  return (
    <div data-testid={testid} className={`flex items-stretch border-y overflow-hidden ${bar}`}>
      <span className="shrink-0 flex items-center gap-2 px-4 sm:px-6 bg-red-600 text-white font-display text-xs font-black uppercase tracking-widest z-10">
        {Icon && <Icon className="w-4 h-4" />} {label}
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track flex items-center h-10 whitespace-nowrap hover:[animation-play-state:paused]" style={{ animationDuration: `${duration}s` }}>
          {loop.map((it, i) => (
            <Link key={i} to={it.href} className="mono-label text-xs font-bold uppercase tracking-wider px-8 hover:text-red-500 transition-colors">
              {it.text}
              {it.meta && <span className="opacity-50 ml-3">{it.meta}</span>}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export const useEventi = (anno) => {
  const [eventi, setEventi] = useState([]);
  useEffect(() => {
    axios.get(`${API}/eventi${anno ? `?anno=${anno}` : ""}`).then((r) => setEventi(r.data)).catch(() => {});
  }, [anno]);
  return eventi;
};

export const useInterviste = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/interviste`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return items;
};
